<template>
    <div :class="isMobile ? 'text-center' : ''">
        <SelectConversionMinutesDropdown
            v-if="isMobile"
            :selectable-conversion-minutes="selectableConversionMinutes"
            :disabled="disabled"
            v-model="selectedMinutes"
        >
            <template v-slot:labelText>
                {{ 'Credits' | trans }}
                <i
                    class="fa fa-question-circle text-info cursor-pointer"
                    @click.stop.prevent="learnMore = !learnMore"
                ></i
                >:
                <br />
            </template>
        </SelectConversionMinutesDropdown>

        <SelectConversionMinutesSlider
            v-else-if="!isMobile"
            :selectable-conversion-minutes="selectableConversionMinutes"
            :disabled="disabled"
            v-model="selectedMinutes"
        >
            <template v-slot:labelText>
                {{ 'Credits' | trans }}
                <i
                    class="fa fa-question-circle text-info cursor-pointer"
                    @click.stop.prevent="learnMore = !learnMore"
                ></i
                >:
            </template>
        </SelectConversionMinutesSlider>

        <Transition name="fade-grow">
            <div class="border px-4 py-3 mb-4 bg-white rounded position-relative mt-3" v-if="learnMore">
                <span
                    class="position-absolute top-0 right-0 pt-2 font-size-150 cursor-pointer lh-1 pr-1"
                    @click.stop.prevent="learnMore = false"
                    >&times;</span
                >
                <p>
                    {{
                        'Every API job that successfully processes files consumes Credits. One Credit is used per server processing minute or part thereof when running a job. Certain premium jobs use more Credits per minute as specified on our pricing page.'
                            | trans
                    }}
                </p>

                <ul class="mb-0 font-size-100 pl-2">
                  <li class="py-1 px-0">{{ 'All bandwidth included' | trans }}</li>
                  <li class="py-1 px-0">{{ 'High priority processing' | trans }}</li>
                  <li class="py-1 px-0">
                    {{ 'File sizes up to %fileSizeLimit%' | trans({ '%fileSizeLimit%': fileSizeLimit }) }}
                  </li>
                  <li class="py-1 px-0">{{ 'Support' | trans }}</li>
                </ul>
            </div>
        </Transition>
    </div>
</template>

<script>
import SelectConversionMinutesSlider from './SelectConversionMinutesSlider';
import SelectConversionMinutesDropdown from './SelectConversionMinutesDropdown';
import TransFilter from '../../../../../qaamgo/modules/sat/components/mixins/TransFilter';
import { translate } from '../../../../../qaamgo/helper/translate';
import { pageStoreMixin } from '../../../../store/page-store';
import { testIsNonEmptyString } from '../../../../../lib/test-and-assert/test-base';

export default {
    name: 'SelectConversionMinutes',
    components: { SelectConversionMinutesDropdown, SelectConversionMinutesSlider },
    mixins: [TransFilter, pageStoreMixin],
    props: {
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    beforeMount() {
        this.checkIfMobile();
        window.addEventListener('resize', this.checkIfMobile);

        this.selectableConversionMinutes = this.getSelectableConversionMinutes();

        if (testIsNonEmptyString(this.selectedMinutesStore)) {
            this.selectedMinutes = this.selectedMinutesStore;
        }
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.checkIfMobile);
    },
    watch: {
        selectedMinutes(minutes) {
            this.store.userPaymentModal.setSelectedSize(minutes);
        },
        selectedMinutesStore(minutes) {
            if (this.selectedMinutes !== minutes) {
                this.selectedMinutes = minutes;
            }
        },
    },
    computed: {
        selectedMinutesStore() {
            return this.store.userPaymentModal.selectedSize;
        },
        fileSizeLimit() {
            return translate('%1 GB', { '%1': '8' });
        },
    },
    methods: {
        checkIfMobile() {
            this.isMobile = window.matchMedia('(max-width: 500px)').matches;
        },
        getSelectableConversionMinutes() {
            const minuteValues = [
                '500',
                '1000',
                '5000',
                '10000',
                '50000',
                '100000',
                '200000',
                '300000',
                '500000',
                '1000000',
            ];

            const selectable = {};

            minuteValues.forEach((minute) => {
                selectable[minute] = this.getFormattedConversionMinutes(minute);
            });

            return selectable;
        },
        getFormattedConversionMinutes(minutes) {
            // format credits string readable
            const addedDot = minutes.replace(/(0{3}){0,1}(0{3}){1,}$/, '.$1.$2');

            // remove double dot
            return addedDot.replace(/\.+/, '.');
        },
    },
    data() {
        return {
            selectedMinutes: '500',
            isMobile: false,
            learnMore: false,
            selectableConversionMinutes: {},
        };
    },
};
</script>
